import PubSub from 'services/PubSub'
import StorageService from 'services/StorageService'
import { api } from 'config'
import { consumer, ecommerce } from 'config/constants'

let cacheRequest = { 
    getFavorites: null,
    signalFavorites: null,
}

const getFavorites = () => {
    const token = StorageService.getItem('sessionData')

    if (!token) {
        return Promise.resolve(new Array())
    }

    if (cacheRequest.getFavorites) {
        return cacheRequest.getFavorites
    }

    let headers = {
        'x-api-key': api.apiKey,
        'Content-Type': 'application/json',
        'token': token,
    }
    if(ecommerce.whiteLabel || ecommerce.JumboTest){
        headers['x-consumer'] = consumer;
        headers['x-account'] = consumer;
    }

    cacheRequest.getFavorites = fetch(`${api.shoppingList}/user/favorites`, {
        method: 'GET',
        headers
    }).then(result => {
        return result.text().then(response => {
            return response.trim() ? JSON.parse(response) : new Array()
        } )
    }).then(result => {
        cacheRequest.getFavorites = null;
        if (result.status) return new Array()
        return result
    }).catch(() => {
        PubSub.dispatch('error')
        return false
    })

    return cacheRequest.getFavorites
}

const updateFavorites = (favorites) => {
    if (cacheRequest.signalFavorites) {
        cacheRequest.signalFavorites.abort()
        cacheRequest.signalFavorites = null
    }
    const token = StorageService.getItem('sessionData')

    let options = {
        method: 'PUT',
        headers: {
            'x-api-key': api.apiKey,
            'Content-Type': 'application/json',
            'token': token,
        },
        body: JSON.stringify(favorites)
    }

    if(ecommerce.whiteLabel || ecommerce.JumboTest) {
        options.headers['x-consumer'] = consumer;
        options.headers['x-account'] = consumer;
    }

    if (window && window.AbortController) {
        cacheRequest.signalFavorites = new AbortController()
        options.signal = cacheRequest.signalFavorites.signal
    }

    return fetch(`${api.shoppingList}/user/favorites`, options).then(result => {
        return result.json()
    }).then(result => {
        if (result.status) return new Array()
        return result
    }).catch(() => {
        PubSub.dispatch('error')
        return false
    }).finally(() => {
        cacheRequest.signalFavorites = null
    })
}

const favoritesService = {
    getFavorites,
    updateFavorites,
}

export default favoritesService